import { activityFeedLoaded } from '../actions/activityFeedLoaded';
import { getActivityFeed } from '../service/getActivityFeed';
import { getActivityFeedStore } from '../store/store';
import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import { activityFeedItemsSeen } from '../actions/activityFeedItemsSeen';
import { trace } from 'owa-trace';

export default function loadActivityFeed() {
    const feedPromise = getActivityFeed(getFilter());
    return feedPromise
        .then(value => {
            if (value) {
                activityFeedLoaded(value);
            }
            if (getActivityFeedStore().isActivityFeedOpen === true) {
                const items = [...getActivityFeedStore().items.values()];
                activityFeedItemsSeen(items.filter(item => !item.isSeen).map(item => item.id));
            }
        })
        .catch(function (err) {
            trace.warn('Failed to load activity feed items ' + err.message);
        });
}

function getFilter(): string[] {
    let typesToExclude: string[] = [];
    getActivityFeedSettingsStore().forEach((value, key) => {
        if (!value) {
            typesToExclude.push(key.toString());
        }
    });
    return typesToExclude;
}
